"use client";

import { useEffect, useState } from "react";
import { AdsMobileCtaBar } from "@/components/ads/ads-tracking";
import { PRICING } from "@/lib/pricing-data";

interface BusinessWalkthroughStickyCtaProps {
  variant?: string;
  pageSlug?: string;
  ctaText?: string;
}

export function BusinessWalkthroughStickyCta({
  variant = "business-paid-v2",
  pageSlug = "business-ads",
  ctaText = "Request a Business walkthrough",
}: BusinessWalkthroughStickyCtaProps = {}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const heroCta = document.getElementById("hero-cta");
    if (!heroCta) return;
    const observer = new IntersectionObserver(([entry]) =>
      setVisible(!entry?.isIntersecting),
    );
    observer.observe(heroCta);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white px-4 pb-4 pt-3 shadow-lg transition-transform md:hidden ${visible ? "translate-y-0" : "translate-y-full"}`}
      inert={!visible}
    >
      <AdsMobileCtaBar
        variant={variant}
        ctaHref="#book-walkthrough"
        ctaText={ctaText}
        pageSlug={pageSlug}
        ctaLocation="mobile-sticky"
        eventName="business_walkthrough_started"
        offer="business"
        emitSignupStart={false}
      />
      <p className="mt-1.5 text-center text-xs text-muted">
        {PRICING.business.display}/month · See how it fits your live jobs
      </p>
    </div>
  );
}
